'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAirplanemodeInactive = function MdAirplanemodeInactive(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 8.8l2.1-2.2 26.3 26.3-2.1 2.1-9.7-9.5v6.1l3.4 2.5v2.5l-5.9-1.6-5.7 1.6v-2.5l3.2-2.5v-9.1l-13.2 4.1v-3.2l9.9-6.3z m16.6 6.2l13.4 8.4v3.2l-5.3-1.6-13.1-13v-6.1c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v9.1z' })
        )
    );
};

exports.default = MdAirplanemodeInactive;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/airplanemode-inactive.js
// module id = 1178
// module chunks = 168707334958949